
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetofivejyotilinga() {



    const cardData =
    {
        keyword: ' Pune to 5 Jyotirlinga Cab',
        heading: 'Prince Cabs: Pune to 5 Jyotirlinga Cab',
        headingDescription: 'Prince Cabs provides specially curated Pune to 5 Jyotirlinga Cab services, ideal for devotees planning a spiritual pilgrimage. Our fleet of well-maintained sedans, SUVs, and luxury vehicles ensures a safe and comfortable journey covering the holy Jyotirlinga temples like Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. With professional chauffeurs, flexible itineraries, and on-time service, we make your Jyotirlinga Darshan convenient and hassle-free. Experience devotion, comfort, and peace with Prince Cabs’ trusted Pune to 5 Jyotirlinga cab service.',

        top: 'Top Places to Visit in 5 Jyotirlinga with Prince Cabs',

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga (Nashik)",
    "description": "Trimbakeshwar Temple, located near Nashik, is one of the most sacred Jyotirlingas in India. Nestled at the foot of the Brahmagiri Hills, it is the origin of the holy Godavari River. The temple has a unique jyotirlinga with three faces symbolizing Brahma, Vishnu, and Mahesh. Pilgrims visit for rituals like Narayan Nagbali and Rudrabhishek. The black stone structure reflects ancient Maratha architecture. Trimbakeshwar is a divine blend of spirituality, history, and natural beauty."
  },
  {
    "title": "Bhimashankar Jyotirlinga (Pune)",
    "description": "Bhimashankar Temple, located in the Sahyadri hills near Pune, is one of Maharashtra’s most visited Jyotirlingas. Surrounded by dense forests and wildlife, it is also home to the Bhimashankar Wildlife Sanctuary. The temple’s Nagara-style architecture and peaceful ambiance attract thousands of devotees. The origin of the Bhima River is also linked to this site. Pilgrims believe that worship here brings peace and prosperity. Bhimashankar is both a spiritual and eco-tourism destination."
  },
  {
    "title": "Grishneshwar Jyotirlinga (Aurangabad)",
    "description": "Grishneshwar Temple, near Ellora Caves in Aurangabad, is the smallest among the 12 Jyotirlingas. The temple, built in red stone, features intricate carvings and a five-tiered shikhara. It was reconstructed in the 18th century by Ahilyabai Holkar. The jyotirlinga is believed to fulfill the wishes of devotees who worship with pure devotion. Women are allowed to enter the sanctum here, unlike many temples. Grishneshwar is both a spiritual and architectural gem."
  },
  {
    "title": "Aundha Nagnath Jyotirlinga (Hingoli)",
    "description": "Aundha Nagnath Temple in Hingoli district is considered the first Jyotirlinga among the 12. Built during the Yadava dynasty, it reflects Hemadpanthi architectural style. The temple is closely associated with saints like Namdev, Jnaneshwar, and Tukaram. Devotees believe that worshipping here frees one from all sins. The temple complex has a peaceful spiritual aura. Aundha Nagnath is Maharashtra’s ancient treasure of devotion."
  },
  {
    "title": "Parli Vaijnath Jyotirlinga (Beed)",
    "description": "Parli Vaijnath Temple, located in Beed district, is a revered Jyotirlinga shrine in Maharashtra. It is believed that Lord Shiva here is worshipped as Vaidhyanath, the divine healer. Devotees visit to seek blessings for health and prosperity. The temple’s black stone structure with a grand entrance is striking. Festivals like Mahashivratri are celebrated with great devotion. Parli Vaijnath stands as a spiritual beacon in the Marathwada region."
  }
],


     "services": [
    {
      "name": "5 Jyotirlinga Tour from Pune",
      "description": "Embark on a spiritual journey with our specially curated 5 Jyotirlinga tour from Pune. Visit the sacred temples with comfortable travel arrangements, experienced drivers, and flexible itineraries tailored to your pilgrimage needs."
    },
    {
      "name": "Pune to Jyotirlinga Cab Package",
      "description": "Book an all-inclusive cab package from Pune to Jyotirlinga sites covering transportation, pick-up/drop-off, and guided stops at each temple. Ideal for hassle-free religious tours with family and friends."
    },
    {
      "name": "Innova for 5 Jyotirlinga Darshan",
      "description": "Travel in spacious comfort with an Innova cab for your 5 Jyotirlinga darshan. Suitable for families and groups, this vehicle offers ample luggage space, air conditioning, and a smooth ride throughout your pilgrimage."
    },
    {
      "name": "Jyotirlinga Tour Taxi from Pune",
      "description": "Reliable Jyotirlinga tour taxi service from Pune providing timely pickups, clean and well-maintained vehicles, and experienced drivers familiar with all five Jyotirlinga locations."
    },
    {
      "name": "Dzire Cab Pune to 5 Jyotirlinga",
      "description": "Opt for an economical and efficient Dzire cab for your Pune to 5 Jyotirlinga trip. Perfect for solo travelers or small groups seeking budget-friendly yet comfortable travel."
    },
    {
      "name": "Etios Car Pune Jyotirlinga Trip",
      "description": "Choose the Etios car rental for your Jyotirlinga pilgrimage from Pune. Enjoy smooth rides, fuel efficiency, and spacious interiors suited for small family trips."
    },
    {
      "name": "5 Jyotirlinga Cab Booking Pune",
      "description": "Book your cab easily for the 5 Jyotirlinga pilgrimage from Pune with flexible scheduling, transparent pricing, and professional service ensuring a smooth and peaceful journey."
    },
    {
      "name": "SUV for 5 Jyotirlinga Tour Pune",
      "description": "Travel with extra comfort and luggage capacity in a powerful SUV cab for your 5 Jyotirlinga tour from Pune. Ideal for larger families or group travelers seeking a robust vehicle."
    },
    {
      "name": "Family Cab 5 Jyotirlinga from Pune",
      "description": "Experience family-friendly travel with dedicated family cabs for the 5 Jyotirlinga darshan from Pune, featuring child safety options, spacious seating, and courteous drivers."
    },
    {
      "name": "Tempo Traveller Pune to Jyotirlinga",
      "description": "Book a Tempo Traveller for large groups or extended family pilgrimages to the 5 Jyotirlingas. Comfortable seating, ample luggage space, and AC options ensure a relaxed journey."
    },
    {
      "name": "Pune Jyotirlinga Round Trip Cab",
      "description": "Plan your round-trip journey for the 5 Jyotirlinga darshan from Pune with coordinated pickup and drop services. Enjoy flexible waiting times and seamless travel arrangements."
    },
    {
      "name": "Pune to 5 Jyotirlinga Religious Tour",
      "description": "Join our guided religious tour packages from Pune covering all five Jyotirlinga temples, combined with expert driver knowledge and thoughtfully planned stops for prayers and sightseeing."
    },
    {
      "name": "Crysta Taxi Pune Jyotirlinga Yatra",
      "description": "Experience a premium pilgrimage with Innova Crysta taxi services for your Jyotirlinga yatra from Pune. Enjoy spacious interiors, superior ride comfort, and reliable service for a divine journey."
    },
    {
      "name": "Affordable 5 Jyotirlinga Cab Pune",
      "description": "Get affordable and trustworthy cab services for your 5 Jyotirlinga tour from Pune. We provide quality vehicles, professional drivers, and transparent pricing to fit your budget."
    },
    {
      "name": "5 Jyotirlinga Darshan with Driver Pune",
      "description": "Book a dedicated cab with an experienced driver for your 5 Jyotirlinga darshan from Pune, ensuring timely pickups, knowledgeable guidance, and a hassle-free travel experience."
    }
  ],
  "tableData": [
    ["5 Jyotirlinga Tour from Pune", "Pune to Jyotirlinga Cab Package"],
    ["Innova for 5 Jyotirlinga Darshan", "Jyotirlinga Tour Taxi from Pune"],
    ["Dzire Cab Pune to 5 Jyotirlinga", "Etios Car Pune Jyotirlinga Trip"],
    ["5 Jyotirlinga Cab Booking Pune", "SUV for 5 Jyotirlinga Tour Pune"],
    ["Family Cab 5 Jyotirlinga from Pune", "Tempo Traveller Pune to Jyotirlinga"],
    ["Pune Jyotirlinga Round Trip Cab", "Pune to 5 Jyotirlinga Religious Tour"],
    ["Crysta Taxi Pune Jyotirlinga Yatra", "Affordable 5 Jyotirlinga Cab Pune"],
    ["5 Jyotirlinga Darshan with Driver Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Service from Pune to 5 Jyotirlinga Temples",
    "WhyChoosedescription": "Prince Cabs offers dependable and comfortable cab services for pilgrimage trips from Pune to the 5 Jyotirlinga temples located within Maharashtra and nearby regions. Our service is perfect for devotees seeking a hassle-free, safe, and spiritually fulfilling journey with timely pickups and smooth rides."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Pilgrimage Travel",
    "WhyChoosedescription": "Our fleet includes sedans and SUVs like Swift Dzire, Ertiga, and Innova, all well-maintained and equipped with spacious seating and ample luggage space to accommodate your travel essentials, religious offerings, and group members comfortably during your Jyotirlinga tour."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pilgrimage Routes",
    "WhyChoosedescription": "Our professional drivers have extensive knowledge of routes to popular Jyotirlinga temples such as Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. They ensure safe driving, efficient navigation, and timely breaks, enhancing your spiritual journey."
  },
  {
    "WhyChooseheading": "Flexible Packages for Customized Pilgrimage Trips",
    "WhyChoosedescription": "Prince Cabs offers tailored packages including one-way trips, round trips, and multi-day rentals to cover multiple temples as per your itinerary. Book easily via phone, WhatsApp, or online with instant confirmation and flexible cancellation policies."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing for Pune to 5 Jyotirlinga cab services is clear and competitive, covering fuel, tolls, driver allowances, and taxes. Multiple secure payment options including UPI, credit/debit cards, net banking, and cash are accepted for your convenience."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Your Safety",
    "WhyChoosedescription": "Each vehicle is thoroughly cleaned and sanitized before every trip. Regular maintenance and safety features such as airbags and seat belts ensure your protection and comfort throughout the pilgrimage journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Travel",
    "WhyChoosedescription": "Our dedicated customer care team is available round the clock to assist with bookings, itinerary changes, and any travel-related queries, ensuring a smooth and worry-free cab experience from Pune to the 5 Jyotirlinga temples."
  }
]























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab services for Pune to 5 Jyotirlinga pilgrimage?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable cab services for visiting the 5 Jyotirlinga temples from Pune, perfect for spiritual and pilgrimage trips.',
    },
    {
        question: 'Which vehicles are available for Pune to 5 Jyotirlinga cab trips?',
        answer: 'We provide various vehicles including Swift Dzire, Ertiga, Innova, and Tempo Traveller to accommodate solo travelers, families, and groups.',
    },
    {
        question: 'How long does the Pune to 5 Jyotirlinga cab journey take?',
        answer: 'The duration depends on the specific Jyotirlingas you plan to visit. Typically, it ranges from 2 to 4 days for a comfortable trip.',
    },
    {
        question: 'Can I book a round-trip cab for the 5 Jyotirlinga pilgrimage?',
        answer: 'Yes, Prince Cabs offers flexible round-trip packages tailored to your pilgrimage itinerary.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for pilgrimage trips?',
        answer: 'Absolutely! All vehicles are regularly cleaned, sanitized, and serviced to ensure safety and comfort throughout your journey.',
    },
    {
        question: 'What are the fares for Pune to 5 Jyotirlinga cab service?',
        answer: 'Fares vary based on vehicle type, distance, and duration. Please contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a cab for Pune to 5 Jyotirlinga pilgrimage?',
        answer: 'You can easily book through our website or by calling our customer support team with your travel details for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Anil Deshpande",
        position: "Pilgrim",
        text: "Prince Cabs made our 5 Jyotirlinga pilgrimage from Pune comfortable and hassle-free. The driver was courteous and knowledgeable.",
        image: "/img/testimonial/testimonial-thumb-jyotirlinga-1.png",
    },
    {
        name: "Ms. Sneha Patil",
        position: "Family Traveler",
        text: "Our spiritual trip to the 5 Jyotirlingas was well-supported by Prince Cabs. The vehicles were clean and the service was excellent.",
        image: "/img/testimonial/testimonial-thumb-jyotirlinga-2.png",
    },
];





















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Pune to 5 Jyotirlinga Cab",
  "description": "Book Pune to 5 Jyotirlinga cab packages with Innova, Dzire, Etios, SUV, Tempo Traveller for a comfortable and affordable Jyotirlinga religious tour and round trip.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "touristType": "Religious Pilgrimage",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to 5 Jyotirlinga Cab Types",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Innova for 5 Jyotirlinga Darshan"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Dzire Cab Pune to 5 Jyotirlinga"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Etios Car Pune Jyotirlinga Trip"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "SUV for 5 Jyotirlinga Tour Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Tempo Traveller Pune to Jyotirlinga"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Crysta Taxi Pune Jyotirlinga Yatra"
        }
      }
    ]
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "additionalProperty": {
    "@type": "PropertyValue",
    "name": "Tour Type",
    "value": "Religious"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to 5 Jyotirlinga Cab | Jyotirlinga Tour Taxi Packages</title>
  <meta
    name="description"
    content="Book Pune to 5 Jyotirlinga cab packages with Innova, Dzire, Etios, SUV, Tempo Traveller for a comfortable and affordable Jyotirlinga religious tour and round trip."
  />
  <meta
    name="keywords"
    content="5 Jyotirlinga Tour from Pune, Pune to Jyotirlinga Cab Package, Innova for 5 Jyotirlinga Darshan, Jyotirlinga Tour Taxi from Pune, Dzire Cab Pune to 5 Jyotirlinga, Etios Car Pune Jyotirlinga Trip, 5 Jyotirlinga Cab Booking Pune, SUV for 5 Jyotirlinga Tour Pune, Family Cab 5 Jyotirlinga from Pune, Tempo Traveller Pune to Jyotirlinga, Pune Jyotirlinga Round Trip Cab, Pune to 5 Jyotirlinga Religious Tour, Crysta Taxi Pune Jyotirlinga Yatra, Affordable 5 Jyotirlinga Cab Pune, 5 Jyotirlinga Darshan with Driver Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/81.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetofivejyotilinga ;